import "../../css/SideNav.css";
import { useState } from "react";

const SideNav = ({ items = {}, isSideNavOpen, sideNavHandler }) => {
  const [content, setContent] = useState(null);

  const getSideNavContent = () => {
    return items[content].content;
  };

  return (
    <>
      <div className="side-nav">
        {Object.entries(items).map(([title, { Icon }]) => (
          <div
            className="side-nav-icon-container"
            onClick={() => {
              if (isSideNavOpen && content === title) {
                sideNavHandler(false);
                setContent(null);
              } else {
                sideNavHandler(true);
                setContent(title);
              }
            }}
          >
            <Icon color={content === title ? "#3498db" : "black"} />
          </div>
        ))}
      </div>
      {isSideNavOpen && (
        <div className="side-nav-content">{getSideNavContent()}</div>
      )}
    </>
  );
};

export default SideNav;
